var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuotes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 34,
    viewBox: "0 0 46 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.78827 34C15.5059 34 19.6353 32.5217 19.6353 26.4609C19.6353 20.2522 15.8236 18.6261 10.1059 18.6261L12.6471 0H5.02357L0.576513 21.8783C-1.01172 29.8609 0.258866 34 9.78827 34ZM36.153 34C41.8706 34 46 32.5217 46 26.4609C46 20.2522 42.1882 18.6261 36.4706 18.6261L39.0118 0H31.3882L26.9412 21.8783C25.353 29.8609 26.6235 34 36.153 34Z",
    fill: "white",
    fillOpacity: 0.12
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuotes);
export default __webpack_public_path__ + "static/media/quotes.54947ea6c4568df58ed9ba52d10f5a20.svg";
export { ForwardRef as ReactComponent };